import React from 'react';
import PropTypes from 'prop-types';

const Checkbox = ({ label, isSelected, onCheckboxChange, value }) => (
    <label className="checkbox-container">
        <input
            type="checkbox"
            name={label}
            checked={isSelected}
            onChange={onCheckboxChange}
            className="form-checkbox"
            value={value}
        />
        {label}
        <span className="checkmark" />
    </label>
);

Checkbox.propTypes = {
    label: PropTypes.string,
    isSelected: PropTypes.bool,
    onCheckboxChange: PropTypes.func,
    value: PropTypes.bool,
};

export default Checkbox;
